/* eslint-disable @typescript-eslint/ban-types */
// Credit: @radix-ui/react-polymorphic v0.4
import * as React from 'react';
/**
 * @example when creating a new polymorphic component
 * const Box = forwardRefWithAs<'div', { variant?: Variant }>()
 *
 * @example when extending an existing polymorphic component
 * const Flex = forwardRefWithAs<typeof Box, { direction?: FlexDirection }>()
 */

export default function forwardRefAs(component) {
  return /*#__PURE__*/React.forwardRef(component);
}